import Routable from '../mixins/routable'

// Returns either a `<router-link>` for internal links or an `<a>` for external links
export default {

  name: 'nandos-router-link',

  mixins: [Routable],

  render(h) {
    const { tag, data } = this.generateRouteLink()
    return h(tag, data, [this.$slots.default])
  }
}
